module.exports = __webpack_public_path__ + "img/icon-sb-mattress-ultra-plus-color-boutique-36.c226f9c.svg";